export const NOT_FOUND_STATUS_CODE = 404;
export const NOT_AUTHORIZED_STATUS_CODE = 401;
export const REDIRECT_STATUS_CODE = 301;
